/**
 * Displays a {FieldGroupCollection} (supplied in the "fieldGroupCollection" attribute).
 */
const fieldsDirective = function () {
    return {
        restrict: 'E',
        transclude: true,
        scope: {
            fieldGroupCollection: '=',
            hideNoValue: '@', // Literal - string 'true' or 'false'
            level: '@', // Literal - string 'order' or 'item'
            lineNumber: '=',
            itemInstance: '=',
            askEarly: '=', // Boolean
            showToCustomers: '=', // Boolean
        },
        link: function link($scope, element, attrs, ctrl, transclude) {
            let cloneElement = null;
            let cloneScope = null;

            $scope.$watchCollection('[fieldGroupCollection, hideNoValue, level, lineNumber, itemInstance, askEarly, showToCustomers]',
                function handleWatchChange(newValues) {
                    if (cloneElement) {
                        cloneScope.$destroy();
                        cloneScope = null;
                        cloneElement.remove();
                        cloneElement = null;
                    }

                    if ($scope.fieldGroupCollection) {
                        if (newValues) {
                            cloneScope = $scope.$new();

                            $scope.fieldGroups = $scope.fieldGroupCollection.filterFieldGroups(
                                {
                                    hideNoValue: $scope.hideNoValue === 'true',
                                    level: $scope.level,
                                    lineNumber: $scope.lineNumber,
                                    itemInstance: $scope.itemInstance,
                                    askEarly: $scope.askEarly,
                                    showToCustomers: $scope.showToCustomers,
                                }
                            );

                            // Allows child <dt-field-instance> elements to use the scope of this directive
                            // (so that $scope.instance exists for them)
                            cloneElement = transclude(
                                cloneScope,
                                function injectClonedElement(clone) {
                                    element.html('');
                                    element.append(clone);
                                }
                            );
                        }
                    }
                });
        },
        template: '<div ng-transclude></div>',
    };
};

module.exports = fieldsDirective;
